import { render } from "./HeadTeacherClassList.vue?vue&type=template&id=67fa4689&scoped=true"
import script from "./HeadTeacherClassList.vue?vue&type=script&lang=js"
export * from "./HeadTeacherClassList.vue?vue&type=script&lang=js"

import "./HeadTeacherClassList.vue?vue&type=style&index=0&id=67fa4689&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fa4689"]])

export default __exports__